import Vue from 'vue';

if (!window.isVueEventBusInitialized) {
  window.EventBus = new class {
    constructor() {
      this.vue = new Vue();
      window.isVueEventBusInitialized = true;
    }

    fire(event, data = null) {
      this.vue.$emit(event, data);
      const domEvent = new Event(event, {
        bubbles: true,
        cancelable: true
      });
      window.dispatchEvent(domEvent);
    }

    listen(event, callback) {
      this.vue.$on(event, callback);
    }

    unlisten(event, callback) {
      this.vue.$off(event, callback);
    }
  };
}

export default window.EventBus;
